<div (clickOutside)="onClickOutside($event)" class="se-combobox">
    <div class="se-combo-container">
        <label class="se-title">{{ title }}</label>
        <div #dropDownContainer class="se-combobox-wrapper">
            <input
                #text
                (click)="onToggleFromInput()"
                (keydown.ArrowDown)="onArrowDown()"
                (keydown.ArrowUp)="onArrowUp()"
                (keydown.Enter)="onEnter()"
                (keydown.Escape)="onEscape()"
                (keydown.Tab)="onClickOutside($event)"
                (ngModelChange)="onTextChange(text.value)"
                [class.someselection]="!!selectedItem"
                [ngModel]="currentText"
                [readonly]="readOnly"
                [title]="currentText"
                class="se-text"
                type="text"
            />

            <se-sprite (click)="onDelete()" *ngIf="enableDelete" class="se-deleteimage" name="close"> </se-sprite>

            <se-sprite (click)="onToggle()" [name]="isOpen ? 'caret-up' : 'caret-down'" class="se-image"> </se-sprite>
        </div>
    </div>
</div>

<ng-template #dropDownTemplate>
    <div
        #dropDownContent
        [hidden]="!isOpen"
        [style.left.px]="elementPosition.left"
        [style.top.px]="elementPosition.top"
        [style.width.px]="elementPosition.width"
        [style.z-index]="zIndex"
        class="se-dropdown"
    >
        <div
            (click)="onSelection(filteredItem)"
            *ngFor="let filteredItem of filteredItems; let i = index"
            [class.active]="filteredItem === activeItem"
            [class.selected]="filteredItem === selectedItem"
            class="combo-item"
        >
            {{ filteredItem[viewPath] }}
        </div>
    </div>
</ng-template>
